define([
    'santa-components',
    'santa-core-utils',
    'lodash',
    'socialCommon',
    'skins',
    'facebookComments/skins/skins.json',
    'componentsCore'
], function (santaComponents, coreUtilsLib, _, socialCommon, skinsPackage, skinsJson, componentsCore) {
    'use strict';

    const commentsEvents = ['xfbml.render', 'xfbml.resize', 'comment.create', 'comment.remove'];

    /**
     * @class components.WFacebookComment
     * @extends {core.skinBasedComp}
     */
    const facebookComments = {
        displayName: 'WFacebookComment',
        mixins: [componentsCore.mixins.skinBasedComp, coreUtilsLib.timersMixins.timeoutsMixin, socialCommon.facebookComponentMixin, socialCommon.socialCompMixin],
        scriptDesc: null,

        propTypes: {
            id: santaComponents.santaTypesDefinitions.Component.id.isRequired,
            isMobileView: santaComponents.santaTypesDefinitions.isMobileView.isRequired,
            compData: santaComponents.santaTypesDefinitions.Component.compData.isRequired,
            compProp: santaComponents.santaTypesDefinitions.Component.compProp.isRequired,
            registerReLayoutPending: santaComponents.santaTypesDefinitions.Layout.registerReLayoutPending.isRequired
        },

        measureComponent(node) {
            const iframe = node.querySelector('iframe');
            return iframe ? [{node, type: 'css', changes: {height: Math.max(node.offsetHeight, iframe.offsetHeight)}}] : [];
        },

        getInitialState() {
            return {
                ready: false,
                lastEventTimeStamp: Date.now()
            };
        },
        commentsAreReady() {
            this.props.registerReLayoutPending(this.props.id);
            this.setState({
                lastEventTimeStamp: Date.now()
            });
        },
        subscribeToFacebookEvents() {
            _.forEach(commentsEvents, function (eventName) {
                window.FB.Event.subscribe(eventName, this.commentsAreReady);
            }.bind(this));
        },
        getHref() {
            return this.getSocialUrl();
        },
        componentDidMount() {
            window.fbAsyncInit = this.subscribeToFacebookEvents; // The Facebook script will call this function when the script will be ready

            if (window.FB) {
                this.subscribeToFacebookEvents();
            }
        },
        componentWillUnmount() {
            if (window.FB) {
                _.forEach(commentsEvents, function (eventName) {
                    window.FB.Event.unsubscribe(eventName, this.commentsAreReady);
                }.bind(this));
            }
        },
        getSkinProperties() {
            return {
                facebook: {
                    children: santaComponents.utils.createReactElement('div', {
                        className: 'fb-comments',
                        'data-href': this.getHref(),
                        'data-width': this.props.isMobileView ? 320 : this.props.compProp.width,
                        'data-numposts': this.props.compProp.numPosts,
                        'data-colorscheme': this.props.compProp.colorScheme,
                        'data-mobile': false
                    })
                }
            };
        }
    };
    componentsCore.compRegistrar.register('wysiwyg.viewer.components.WFacebookComment', facebookComments);
    skinsPackage.skinsMap.addBatch(skinsJson);

    return facebookComments;
});
